angular.module('myServices', []);

// require('./user/userService.js');
require('./global/globalService');
require('./team/teamService');
require('./group/groupService');
require('./class/classService');
